<div class="layout-footer clearfix">
    <div class="layout-footer-center" style="color: #313945;">
        <p>© {{ anio }} | UTIC SRS </p>
    </div>
</div>